let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dhqhP")).then(() => parcelRequire('9oWS2'));